import { Button, Table, TableColumnsType } from 'antd';
import {
	ApplicationSummary,
	Pagination,
	PagingConfig,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { tablePaginationConfiguration } from '../../../shared/Utils';

interface CTDApplicationSummaryTableProps {
	applications: ApplicationSummary[] | undefined;
	onEvaluateClick: (application: ApplicationSummary) => void;
	onPageChange: (page: number, pageSize: number) => void;
	pageConfig: PagingConfig;
	pagination: Pagination;
}

export const CTDApplicationSummaryTable = (
	props: CTDApplicationSummaryTableProps
) => {
	const { t } = useTranslation();
	const {
		applications,
		onEvaluateClick,
		onPageChange,
		pageConfig,
		pagination,
	} = props;

	const tablePaginationConfig = tablePaginationConfiguration(
		pageConfig,
		pagination,
		onPageChange
	);

	const handleViewClick = useCallback(
		(application: ApplicationSummary) => {
			onEvaluateClick(application);
		},
		[onEvaluateClick]
	);

	const CTDApplicationTableColumns: TableColumnsType<ApplicationSummary> = [
		{
			title: t('fullName'),
			dataIndex: 'fullName',
			key: 'fullName',
			render: (__, record, index) => (
				<span key={index}>{`${record.applicant.firstName ?? ''} ${
					record.applicant.lastName ?? ''
				}`}</span>
			),
		},
		{
			title: t('gender'),
			dataIndex: 'gender',
			key: 'gender',
			render: (__, record, index) => (
				<span key={index}>{record.applicant.gender || '-'}</span>
			),
		},
		{
			title: t('idCard'),
			dataIndex: 'idCard',
			key: 'idCard',
			render: (__, record, index) => (
				<span key={index}>{record.applicant.srcmid || '-'}</span>
			),
		},
		{
			title: t('zone'),
			dataIndex: 'zone',
			key: 'zone',
			render: (__, record, index) => (
				<span key={index}>{record.center.zone || '-'}</span>
			),
		},
		{
			title: t('action'),
			key: 'action',
			width: 200,
			render: (__, record) => (
				<Button
					block
					className="border border-primary-blue text-primary-blue font-bold mt-2"
					onClick={() => handleViewClick(record)}
				>
					{t('view')}
				</Button>
			),
		},
	];

	return (
		<>
			<Table
				columns={CTDApplicationTableColumns}
				dataSource={applications}
				pagination={{ ...tablePaginationConfig, className: 'pr-2' }}
				size="middle"
				scroll={{ x: 'max-content' }}
				rowClassName={() => 'border-b border-gray-300 bg-white'}
				className="w-full overflow-x-auto border border-solid border-gray-200 rounded-md"
			/>
		</>
	);
};
